import React, { FC, useMemo } from 'react';
// mui components
import { Grid } from '@mui/material';
// components
import Spinner from 'components/spinner';
// utils
import { API_URL } from 'utils/axios.instance';
// styles
import { styles } from './styles';

type TViewDocxProps = {
  src: string;
  name: string;
};

const ViewDocx: FC<TViewDocxProps> = ({ src }) => {
  const previewURL = useMemo(() => {
    if (!src) {
      return null;
    }

    const proxyUrl = `${API_URL}file-cabinet/public/preview?url=${encodeURIComponent(src)}`;

    return encodeURIComponent(proxyUrl);
  }, [src]);

  if (!previewURL) {
    return <Spinner />;
  }

  return (
    <Grid sx={styles.container}>
      <iframe
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${previewURL}`}
        style={{ outline: 'none' }}
      />
    </Grid>
  );
};

export default ViewDocx;
